import React, { useState } from 'react'
import {
  AccordionSummary as ExpansionPanelSummary,
  Grid,
  Typography,
} from '@material-ui/core'
import DragHandleIcon from '@material-ui/icons/DragHandle'
import EditQuestionTitleField from '../Molecules/EditDialogTitle'
import ReactHtmlParser from 'react-html-parser'
import { renderQuestionHeaderElements } from '../Molecules/RenderQuestionHeaderElements'
import { getLocalizedValue } from '../../utils/localeUtils'
import useLocale from '../../customHooks/useLocale'

export const ExpansionRule = ({
  question,
  provided,
  previewRef,
  handleRef,
  handlerId,
  index,
  ...props
}) => {
  const [editTitle, setEditTitle] = useState(false)
  const locale = useLocale()
  const displayIndex = index + 1

  return (
    <ExpansionPanelSummary
      ref={previewRef}
      data-handler-id={handlerId}
      {...props}
    >
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
        spacing={1}
      >
        <Grid
          item
          xs
          style={{
            textAlign: 'left',
          }}
          data-cy={'draghandle' + displayIndex}
        >
          <div ref={handleRef}>
            <DragHandleIcon />
          </div>
        </Grid>

        <Grid
          item
          xs
          style={{
            textAlign: 'left',
          }}
        >
          <Typography variant='h5'>{displayIndex}</Typography>
        </Grid>
        <Grid
          item
          xs={7}
          style={{
            textAlign: 'left',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
          }}
          id={displayIndex}
        >
          {editTitle ? (
            <EditQuestionTitleField
              question={question}
              onComplete={() => setEditTitle(false)}
            />
          ) : (
            <Typography
              onDoubleClick={() =>
                question.type === 'raw'
                  ? setEditTitle(false)
                  : setEditTitle(true)
              }
              variant={question.type === 'raw' ? 'inherit' : 'h5'}
            >
              {question.type === 'raw'
                ? ReactHtmlParser(getLocalizedValue(question.content, locale))
                : getLocalizedValue(question.title, locale)}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          xs={3}
          style={{
            textAlign: 'right',
          }}
        >
          {renderQuestionHeaderElements(question, index)}
        </Grid>
      </Grid>
    </ExpansionPanelSummary>
  )
}
